// Theme-Presets für Agent-Landing-Pages.
// Jeder Preset liefert die Farb-Tokens für Hero-Gradient, Accent (Preis-Text,
// Highlights) und optional Body-Background.

export type ThemeColors = {
  accent: string;       // Hauptfarbe — Preis, Buttons, Avatar-Initials
  gradientFrom: string; // Hero-Gradient start
  gradientTo: string;   // Hero-Gradient end
  bg: string;           // Body background
  cardBg: string;       // Product-Card background
  ink: string;          // Haupt-Textfarbe
  inkMuted: string;     // Sekundär-Text
};

const PRESETS: Record<string, ThemeColors> = {
  default: {
    accent: "#f97316",
    gradientFrom: "#f97316",
    gradientTo: "#f59e0b",
    bg: "#fef6ec",
    cardBg: "#ffffff",
    ink: "#1f1108",
    inkMuted: "#7a6453",
  },
  sunset: {
    accent: "#e11d48",
    gradientFrom: "#f43f5e",
    gradientTo: "#fb923c",
    bg: "#fff5f0",
    cardBg: "#ffffff",
    ink: "#3a1a14",
    inkMuted: "#8a5a4a",
  },
  ocean: {
    accent: "#0ea5e9",
    gradientFrom: "#0ea5e9",
    gradientTo: "#06b6d4",
    bg: "#f0fafe",
    cardBg: "#ffffff",
    ink: "#0c2a3d",
    inkMuted: "#557080",
  },
  mono: {
    accent: "#111827",
    gradientFrom: "#374151",
    gradientTo: "#111827",
    bg: "#fafaf9",
    cardBg: "#ffffff",
    ink: "#111827",
    inkMuted: "#6b7280",
  },
  forest: {
    accent: "#16a34a",
    gradientFrom: "#16a34a",
    gradientTo: "#65a30d",
    bg: "#f3faf3",
    cardBg: "#ffffff",
    ink: "#102818",
    inkMuted: "#557a5e",
  },
  berry: {
    accent: "#a855f7",
    gradientFrom: "#a855f7",
    gradientTo: "#ec4899",
    bg: "#faf4ff",
    cardBg: "#ffffff",
    ink: "#2a1336",
    inkMuted: "#735386",
  },
  midnight: {
    accent: "#fbbf24",
    gradientFrom: "#312e81",
    gradientTo: "#0f172a",
    bg: "#0f172a",
    cardBg: "#1e293b",
    ink: "#f1f5f9",
    inkMuted: "#94a3b8",
  },
  candy: {
    accent: "#ec4899",
    gradientFrom: "#ec4899",
    gradientTo: "#f472b6",
    bg: "#fff5fa",
    cardBg: "#ffffff",
    ink: "#3c1431",
    inkMuted: "#88547a",
  },
};

export function getThemeColors(preset: string, accentOverride?: string | null): ThemeColors {
  const base = PRESETS[preset] || PRESETS.default;
  if (accentOverride && /^#[0-9a-fA-F]{6}$/.test(accentOverride)) {
    return { ...base, accent: accentOverride, gradientFrom: accentOverride };
  }
  return base;
}

export const ALL_PRESETS = Object.keys(PRESETS) as Array<keyof typeof PRESETS>;

export const PRESET_LABELS: Record<string, string> = {
  default: "Standard (Orange)",
  sunset: "Sunset",
  ocean: "Ocean",
  mono: "Mono",
  forest: "Forest",
  berry: "Berry",
  midnight: "Midnight (dunkel)",
  candy: "Candy",
};
